import CrossIcon from "@atlaskit/icon/core/cross";
import type {ReactNode} from "react";
import {AnankeButtonGroup} from "@vesta/ananke/components/anankeButtonGroup";
import {AnankeHeading} from "@vesta/ananke/components/anankeHeading";
import {AnankeIconButton} from "@vesta/ananke/components/anankeIconButton";

export function StandardModalHeader({
    title,
    onClose,
    headerActions,
    closeDisabled = false,
    headingId,
    className,
}: {
    title: ReactNode;
    onClose: () => void;
    headerActions?: ReactNode;
    closeDisabled?: boolean;
    headingId?: string;
    className?: string;
}) {
    const titleNode =
        typeof title === "string" ? <AnankeHeading size="small">{title}</AnankeHeading> : title;

    return (
        <div
            className={
                className ??
                "grid w-full min-w-0 shrink-0 grid-cols-[minmax(0,1fr)_max-content] items-center gap-ds-space-200 px-ds-space-250 py-ds-space-150"
            }
        >
            <div
                id={headingId}
                className={typeof title === "string" ? "*:line-clamp-1" : "min-w-0 *:line-clamp-1"}
            >
                {titleNode}
            </div>
            <AnankeButtonGroup>
                {headerActions}
                <AnankeIconButton
                    type="button"
                    appearance="subtle"
                    icon={CrossIcon}
                    label="Close"
                    isDisabled={closeDisabled === true}
                    onClick={onClose}
                />
            </AnankeButtonGroup>
        </div>
    );
}

export function StandardModalHeaderDivider() {
    return <div className="h-[var(--ds-border-width)] w-full shrink-0 bg-ds-border" />;
}
